module.exports = __webpack_public_path__ + "img/title_uk.33e3b48c.svg";